import { render, staticRenderFns } from "./InvalidPermission.vue?vue&type=template&id=0b716ab2&"
import script from "./InvalidPermission.vue?vue&type=script&lang=ts&"
export * from "./InvalidPermission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports